import React from "react";
import { views } from "../config/settings";

function Slider({viewNum}) {
   return (
   <div>
      {views[viewNum]}
   </div>
);
}

export default Slider;
